import { Stack } from '@mui/material';

import { useFeatureNavigate, useFeatureFlags } from '@/contexts/FeatureFlagContext';

export default function Logo({ clickable = true }: { clickable?: boolean }) {
  const navigate = useFeatureNavigate();
  const { getHomeRoute } = useFeatureFlags();

  const handleLogoClick = () => {
    const homeRoute = getHomeRoute();
    navigate(homeRoute);
  };

  return (
    <Stack
      direction="row"
      sx={{ display: 'flex', alignItems: 'center', cursor: clickable ? 'pointer' : 'default' }}
      onClick={clickable ? handleLogoClick : undefined}
    >
      <img src="/img/MolmoSpaces.svg" alt="Logo" style={{ width: '300px' }} />
    </Stack>
  );
}
